import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_Fc1t7ISC6VLT: {
	id: 'prd_Fc1t72DEV2ISC6VLT'
	ident: 'prd_Fc1t7ISC6VLT'
	sku: 'simple_workbook_bundle_19_99_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_cVv242DEV2LBDOCb8'
		amount: 49
		amount_usd: 19.99
		currency: 'USD'
		amount_with_discount: 19.99
		discount: 29.01
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_Fc1t7ISC6VLT, OneTimeProduct>
const prd_Fc1t7ISC6VLT = { ident: 'prd_Fc1t7ISC6VLT' } as typeof _prd_Fc1t7ISC6VLT

export default prd_Fc1t7ISC6VLT
